import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-add-property-modal',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './add-property-modal.component.html',
  styleUrl: './add-property-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPropertyModalComponent {
  @Input() public address: string = '';
  @Input() public city: string = '';
  @Input() public state: string = '';
  @Input() public latitude: string = '';
  @Input() public longitude: string = '';
  @Input() public saveOnlyLatLng: Function = () => {};
  @Input() public saveCompleteAddress: Function = () => {};
  @Input() public onCancel: Function = () => {};

  constructor(
    public dialogRef: MatLegacyDialogRef<AddPropertyModalComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.address = data.address;
      this.city = data.city;
      this.state = data.state;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.saveCompleteAddress = data.saveCompleteAddress;
      this.saveOnlyLatLng = data.saveOnlyLatLng;
      this.onCancel = data.onCancel;
    }
  }
}
